
import { ref} from "vue";

export function useDiscountType() {

    const currency = 'XOF'

    const discountType = ref({
        percent : {
            value: 'percent',
            name: i18n.global.t('discount.type.percent'),
            symbol: '%'
        },
        fixed : {
            value: 'amount',
            name: i18n.global.t('discount.type.amount'),
            symbol: currency
        },
    })


    return { discountType }
}
